import { render, staticRenderFns } from "./DispatchList.vue?vue&type=template&id=7456e02a&scoped=true&"
import script from "./DispatchList.vue?vue&type=script&lang=ts&"
export * from "./DispatchList.vue?vue&type=script&lang=ts&"
import style0 from "./DispatchList.vue?vue&type=style&index=0&id=7456e02a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7456e02a",
  null
  
)

export default component.exports